module.exports = __webpack_public_path__ + "img/flugzeug.9571b5c0.png";